import FilterDatePicker from 'shared/Table/shared/FilterDatePicker/FilterDatePicker';

export default FilterDatePicker;
